import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  notifications: [],
  unReadCount: 0,
  unReadMessageCount: 0,
};
export const notificationSlice = createSlice({
  name: "notificationSlice",
  initialState,
  reducers: {
    allNotification: (state, action) => {
      state.notifications = action.payload;
    },
    unReadCount: (state, action) => {
      state.unReadCount = action.payload;
    },
    updateUnReadCount: (state, action) => {
      if (action.payload == "add") {
        state.unReadCount++;
      } else {
        state.unReadCount--;
      }
    },
    updateUnReadMessageCount: (state, action) => {
      if (action.payload == "add") {
        state.unReadMessageCount++;
      } else if (action.payload == "minus") {
        state.unReadMessageCount--;
      } else {
        state.unReadMessageCount = action.payload;
      }
    },
    addNotification: (state, action) => {
      state.notifications.unshift(action.payload);
    },
  },
});

export const {
  allNotification,
  unReadCount,
  addNotification,
  updateUnReadCount,
  updateUnReadMessageCount,
} = notificationSlice.actions;
export default notificationSlice.reducer;
